/**
 * BoxImageLink Class
 */
export class BoxImageLink {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.allBlocks = document.querySelectorAll( containerEl );
		if ( ! this.allBlocks || this.allBlocks.length === 0 ) {

			return false;

		}

		this.init();

	}

	/**
	 * Init
	 *
	 * @return {void}
	 */
	init() {

		if ( this.allBlocks.length > 0 ) {

			this.allBlocks.forEach( ( block ) => {

				if ( block.classList.contains( 'is-box-image-link' ) ) {

					const buttonLink = block.querySelector( '.wp-block-button__link' );
					const boxImage = block.querySelector( '.b-box__image-wrapper img' );

					if ( buttonLink && boxImage ) {

						const href = buttonLink.getAttribute( 'href' );

						if ( href === null ) {

							return;

						}
						const target = buttonLink.getAttribute( 'target' );
						const rel = buttonLink.getAttribute( 'rel' );

						const linkElement = document.createElement( 'a' );
						linkElement.setAttribute( 'href', href );

						if ( target && rel ) {

							linkElement.setAttribute( 'rel', rel );
							linkElement.setAttribute( 'target', target );

						}

						boxImage.parentNode.insertBefore( linkElement, boxImage );
						linkElement.appendChild( boxImage );

					}

				}

			} );

		}

	}

}
